import { Avatar, Input, TextInput } from "@mantine/core";
import "dayjs/locale/tr";
import styled from "styled-components";
import { MagnifyingGlassIcon } from "@heroicons/react/16/solid";
import { theme } from "../../../theme";

/*
 * `clearable` KALDIRILDI: Mantine `TextInput`'te böyle bir prop yok, bu yüzden
 * doğrudan DOM'a sızıyor ve React "Received `true` for a non-boolean attribute"
 * uyarısı basıyordu. Hiçbir çağrı yeri de bu prop'u geçmiyordu — sessiz bir
 * kalıntıydı. (Temizleme düğmesi gereken yerlerde `CustomSelect` kullanılıyor.)
 */
const CustomSearchInput = ({
  w = 190,
  h = 44,
  withAsterisk = false,
  leftSection,
  ...rest
}: any) => {
  return (
    <StyledInput
      w={w}
      $height={h}
      withAsterisk={withAsterisk}
      leftSectionPointerEvents="none"
      leftSection={
        leftSection ?? (
          <>
            <MagnifyingGlassIcon
              height={24}
              style={{ color: theme.colors.brand.normal }}
            />
          </>
        )
      }
      {...rest}
    />
  );
};

export default CustomSearchInput;

const StyledInput = styled(TextInput)<{ $height?: number | string }>`
  .mantine-Input-input {
    height: ${({ $height }) => `${$height}px`};
  }
`;
